import psPlatformClient from "../../../psPlatformClient";

export async function getLinkedVendors(
  companyId: string
): Promise<string[]> {
  const response = await psPlatformClient<null, string[]>({
    method: 'post',
    url: `/am/${companyId}/energy-devices/linked-vendors`,
  })
  return response.data;
}

export async function initiateVendorLink(
  companyId: string, 
  vendor: string
): Promise<{ linkUrl: string }> {
  const response = await psPlatformClient<null, { linkUrl: string }>({
    method: 'get',
    url: `/am/${companyId}/energy-devices/${vendor}/link`,
  })
  return response.data;
}

// export async function registerVendorLinkingViaOauth2AuthorizationCode(
//   companyId: string, 
//   vendor: string,
//   code: string
// ): Promise<boolean> {
//   const response =await psPlatformClient<{code: string}, boolean>({
//     method: 'post',
//     url: `/am/${companyId}/energy-devices/${vendor}/link/oauth2/authorization-code`,
//     data: { code }
//   })
//   return response.data;
// }

export async function registerVendorLinkingViaAccessToken(
  companyId: string, 
  vendor: string,
  accessToken: string
): Promise<boolean> {
  const response =await psPlatformClient<{accessToken: string}, boolean>({
    method: 'post',
    url: `/am/${companyId}/energy-devices/${vendor}/link/access-token`,
    data: { accessToken }
  })
  return response.data;
}

export async function getProjectNamesToSync(
  companyId: string
): Promise<string[]> {
  const response =await psPlatformClient<null, string[]>({
    method: 'get',
    url: `/am/${companyId}/energy-devices/project-names-to-sync`,
  })
  return response.data;
}

export async function syncDevicesData(
  companyId: string,
  collection: string
): Promise<{success: boolean}> {
  const response =await psPlatformClient<{collection:string}, {success: boolean}>({
    method: 'post',
    url: `/am/${companyId}/energy-devices/sync-data`,
    data: {collection}
  })
  return response.data;
}

// export async function disconnectVendor(
//   companyId: string, 
//   vendor: string
// ): Promise<{ success: boolean }> {
//   return (await psPlatformClient<any, any>({
//     method: 'delete',
//     url: `/am/${companyId}/icp4/${vendor}/disconnect`,
//   })).data as { success: boolean };
// }

// export async function syncVendorData(
//   companyId: string, 
//   vendor: string
// ): Promise<{ success: boolean; message?: string }> {
//   return (await psPlatformClient<any, any>({
//     method: 'post',
//     url: `/am/${companyId}/icp4/${vendor}/sync`,
//   })).data as { success: boolean; message?: string };
// }